import type { Driver, PreferredDriver } from '@bambi/api-client/schemas';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { createColumnHelper } from '@tanstack/react-table';
import { truncate } from 'lodash-es';

import { ManageCell } from './ManageCell';
import { isHardRule, preferenceTypeDisplay } from './preferenceType';

const columnHelper = createColumnHelper<PreferredDriver>();

export function createColumns(
  driverNameLookup: Record<string, string>,
  passengerId: string,
  passengerName: string,
  drivers: Driver[]
) {
  return [
    columnHelper.accessor('driver', {
      id: 'driver',
      header: 'Driver',
      cell: ({ getValue }) => driverNameLookup[getValue()] ?? getValue(),
      meta: { enableHeaderMenu: false },
    }),
    columnHelper.accessor('preference_type', {
      id: 'preference_type',
      header: 'Rule',
      cell: ({ row }) => {
        const type = row.original.preference_type;
        const label = preferenceTypeDisplay[type];
        if (isHardRule(type)) {
          return (
            <span
              className="flex items-center gap-1"
              title="Hard rule — cannot be overridden"
            >
              <ExclamationTriangleIcon
                className="h-4 w-4 text-amber-500"
                aria-label="Hard rule"
                data-testid="hard-rule-icon"
              />
              {label}
            </span>
          );
        }
        return label;
      },
      meta: { enableHeaderMenu: false },
    }),
    columnHelper.accessor('notes', {
      id: 'notes',
      header: 'Notes',
      cell: ({ row }) => truncate(row.original.notes ?? '-', { length: 75 }),
      meta: { enableHeaderMenu: false },
    }),
    columnHelper.display({
      id: 'actions',
      header: 'Manage',
      cell: ({ row }) => (
        <ManageCell
          preferredDriver={row.original}
          passengerId={passengerId}
          passengerName={passengerName}
          drivers={drivers}
        />
      ),
      meta: { enableHeaderMenu: false },
    }),
  ];
}
